module.exports = "It works!\n\n- Make it more interesting\n\n- Nest content\n\n- Pass props\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/notes_5.md
// module id = 1472
// module chunks = 0